export default "__VITE_ASSET__CRM7q39p__"